import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n.js';  // i18n configuration

// Crear el root del componente
const root = ReactDOM.createRoot(document.getElementById('root'));

// Renderizar la aplicación envuelta con el AuthProvider
root.render(
  <React.StrictMode>
      <App />
  </React.StrictMode>
);

// Registrar reportes de rendimiento
reportWebVitals();
